// extracted by mini-css-extract-plugin
module.exports = {"ActivateButton":"AttachedFilesTable_ActivateButton__2OVK8","DeleteButton":"AttachedFilesTable_DeleteButton__1mxLx","EditButton":"AttachedFilesTable_EditButton__GGAIZ"};